import React from 'react';
import Top from '../components/Top';
import Card from '../components/Card';
import Section from '../components/Section';
import AddRemoveInputs from '../components/AddRemoveInputs';

export default function Blog() {
  return (
    <>
      <Top />
      <Section />
      <AddRemoveInputs />
      <Card />
    </>
  );
}
